import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";

import { HelmetProvider } from "react-helmet-async";
import { Provider as PersistProvider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";

import { default as RouterProvider } from "./router/index.jsx";

import "./i18n";

import App from "./App";
import MainLoading from "./components/main-loading/index.jsx";

import "animate.css/animate.min.css";
import "react-toastify/dist/ReactToastify.min.css";
import "./styles/index.scss";

import { store, persistor } from "./redux/store";

const helmetContext = {};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Suspense fallback={<MainLoading />}>
    {["LOCAL"].includes(process.env.REACT_APP_ENV) ? (
      <HelmetProvider context={helmetContext}>
        <PersistProvider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <RouterProvider>
              <App />
            </RouterProvider>
          </PersistGate>
        </PersistProvider>
      </HelmetProvider>
    ) : (
      <React.StrictMode>
        <HelmetProvider context={helmetContext}>
          <PersistProvider store={store}>
            <PersistGate loading={null} persistor={persistor}>
              <RouterProvider>
                <App />
              </RouterProvider>
            </PersistGate>
          </PersistProvider>
        </HelmetProvider>
      </React.StrictMode>
    )}
  </Suspense>
);
